import { api } from './authService'

export const apiService = {
  // ==================== DASHBOARD ====================
  async getDashboardData() {
    const response = await api.get('/api/dashboard/overview')
    return response.data
  },

  async getRealTimeData() {
    const response = await api.get('/api/dashboard/realtime')
    return response.data
  },

  async getAnalytics(timeframe = '6m') {
    const response = await api.get(`/api/dashboard/analytics?timeframe=${timeframe}`)
    return response.data
  },

  // ==================== VEÍCULOS ====================
  async getVehicles(params = {}) {
    const response = await api.get('/api/vehicles', { params })
    return response.data
  },

  async getVehicle(id) {
    const response = await api.get(`/api/vehicles/${id}`)
    return response.data
  },

  async createVehicle(vehicleData) {
    const response = await api.post('/api/vehicles', vehicleData)
    return response.data
  },

  async updateVehicle(id, vehicleData) {
    const response = await api.put(`/api/vehicles/${id}`, vehicleData)
    return response.data
  },

  async deleteVehicle(id) {
    const response = await api.delete(`/api/vehicles/${id}`)
    return response.data
  },

  async exportVehicles(format = 'csv') {
    const response = await api.post('/api/vehicles/export', { format })
    return response.data
  },

  // ==================== CLIENTES ====================
  async getClients(params = {}) {
    const response = await api.get('/api/clients', { params })
    return response.data
  },

  async getClient(id) {
    const response = await api.get(`/api/clients/${id}`)
    return response.data
  },

  async createClient(clientData) {
    const response = await api.post('/api/clients', clientData)
    return response.data
  },

  async updateClient(id, clientData) {
    const response = await api.put(`/api/clients/${id}`, clientData)
    return response.data
  },

  async importClients(csvFile) {
    const formData = new FormData()
    formData.append('csvFile', csvFile)
    const response = await api.post('/api/clients/import', formData)
    return response.data
  },

  // ==================== CONTRATOS ====================
  async getContracts(params = {}) {
    const response = await api.get('/api/contracts', { params })
    return response.data
  },

  async getContractsKanban() {
    const response = await api.get('/api/contracts/kanban')
    return response.data
  },

  async createContract(contractData) {
    const response = await api.post('/api/contracts', contractData)
    return response.data
  },

  async updateContract(id, contractData) {
    const response = await api.put(`/api/contracts/${id}`, contractData)
    return response.data
  },

  async updateContractDueDay(id, dia_vencimento_boleto) {
    const response = await api.patch(`/api/contracts/${id}/dia-vencimento`, { dia_vencimento_boleto })
    return response.data
  },

  async renewContract(id, data) {
    const response = await api.patch(`/api/contracts/${id}/renew`, data)
    return response.data
  },

  async saveMonthDueDate(contractId, year, month, due_date) {
    const response = await api.patch(`/api/contracts/${contractId}/month-due-date`, { year, month, due_date })
    return response.data
  },

  async signContract(id, signerData) {
    const response = await api.post(`/api/contracts/${id}/sign`, signerData)
    return response.data
  },

  async getContractReport(params = {}) {
    const response = await api.get('/api/contracts/report', { params })
    return response.data
  },

  // ==================== NOTIFICAÇÕES ====================
  async getNotifications(params = {}) {
    const response = await api.get('/api/notifications', { params })
    return response.data
  },

  async markNotificationRead(id) {
    const response = await api.put(`/api/notifications/${id}/read`)
    return response.data
  },

  async markAllNotificationsRead() {
    const response = await api.post('/api/notifications/mark-all-read')
    return response.data
  },

  async deleteNotification(id) {
    const response = await api.delete(`/api/notifications/${id}`)
    return response.data
  },

  async getNotificationStats() {
    const response = await api.get('/api/notifications/stats')
    return response.data
  },

  // ==================== WEBMAIL ====================
  async createAutologinToken() {
    const response = await api.post('/api/webmail/autologin')
    return response.data
  },

  // ==================== INTEGRAÇÕES ====================
  async getIntegrationsStatus() {
    const response = await api.get('/api/integrations/status')
    return response.data
  },

  async testIntegration(integration) {
    const response = await api.post(`/api/integrations/test/${integration}`)
    return response.data
  },

  async createAsaasCharge(chargeData) {
    const response = await api.post('/api/integrations/asaas/charge', chargeData)
    return response.data
  },

  async cancelAsaasCharge(chargeId) {
    const response = await api.delete(`/api/asaas/charges/${chargeId}`)
    return response.data
  },

  async getGpsVehicles() {
    const response = await api.get('/api/integrations/getrak/vehicles')
    return response.data
  },

  async getVehicleTrack(vehicleId, params = {}) {
    const response = await api.get(`/api/integrations/getrak/vehicle/${vehicleId}/track`, { params })
    return response.data
  },

  // ==================== INTEGRAÇÕES ====================
  async getIntegrations() {
    const response = await api.get('/api/integrations')
    return response.data
  },

  async getIntegrationFeatures(name) {
    const response = await api.get(`/api/integrations/${name}/features`)
    return response.data
  },

  async updateIntegration(name, data) {
    const response = await api.put(`/api/integrations/${name}`, data)
    return response.data
  },

  async updateIntegrationFeature(integrationName, featureKey, data) {
    const response = await api.put(`/api/integrations/${integrationName}/features/${featureKey}`, data)
    return response.data
  },

  async testIntegration(name) {
    const response = await api.post(`/api/integrations/${name}/test`)
    return response.data
  },

  // ==================== CADASTROS ====================

  // Fornecedores
  async getSuppliers(params = {}) {
    const response = await api.get('/api/suppliers', { params })
    return response.data
  },

  async getSupplier(id) {
    const response = await api.get(`/api/suppliers/${id}`)
    return response.data
  },

  async createSupplier(supplierData) {
    const response = await api.post('/api/suppliers', supplierData)
    return response.data
  },

  async updateSupplier(id, supplierData) {
    const response = await api.put(`/api/suppliers/${id}`, supplierData)
    return response.data
  },

  async deleteSupplier(id) {
    const response = await api.delete(`/api/suppliers/${id}`)
    return response.data
  },

  // Contas Bancárias
  async getBankAccounts(params = {}) {
    const response = await api.get('/api/bank-accounts', { params })
    return response.data
  },

  async createBankAccount(accountData) {
    const response = await api.post('/api/bank-accounts', accountData)
    return response.data
  },

  async updateBankAccount(id, accountData) {
    const response = await api.put(`/api/bank-accounts/${id}`, accountData)
    return response.data
  },

  async deleteBankAccount(id) {
    const response = await api.delete(`/api/bank-accounts/${id}`)
    return response.data
  },

  // Formas de Pagamento
  async getPaymentMethods(params = {}) {
    const response = await api.get('/api/payment-methods', { params })
    return response.data
  },

  async createPaymentMethod(methodData) {
    const response = await api.post('/api/payment-methods', methodData)
    return response.data
  },

  async updatePaymentMethod(id, methodData) {
    const response = await api.put(`/api/payment-methods/${id}`, methodData)
    return response.data
  },

  async deletePaymentMethod(id) {
    const response = await api.delete(`/api/payment-methods/${id}`)
    return response.data
  },

  // Classes Financeiras
  async getFinancialClasses(params = {}) {
    const response = await api.get('/api/financial-classes', { params })
    return response.data
  },

  async createFinancialClass(classData) {
    const response = await api.post('/api/financial-classes', classData)
    return response.data
  },

  async updateFinancialClass(id, classData) {
    const response = await api.put(`/api/financial-classes/${id}`, classData)
    return response.data
  },

  async deleteFinancialClass(id) {
    const response = await api.delete(`/api/financial-classes/${id}`)
    return response.data
  },

  async seedFinancialClasses() {
    const response = await api.post('/api/financial-classes/seed')
    return response.data
  },

  // Tipos de Manutenção
  async getMaintenanceTypes(params = {}) {
    const response = await api.get('/api/maintenance-types', { params })
    return response.data
  },

  async createMaintenanceType(typeData) {
    const response = await api.post('/api/maintenance-types', typeData)
    return response.data
  },

  async updateMaintenanceType(id, typeData) {
    const response = await api.put(`/api/maintenance-types/${id}`, typeData)
    return response.data
  },

  async deleteMaintenanceType(id) {
    const response = await api.delete(`/api/maintenance-types/${id}`)
    return response.data
  },

  // Tipos de Documento
  async getDocumentTypes(params = {}) {
    const response = await api.get('/api/document-types', { params })
    return response.data
  },

  async createDocumentType(typeData) {
    const response = await api.post('/api/document-types', typeData)
    return response.data
  },

  async updateDocumentType(id, typeData) {
    const response = await api.put(`/api/document-types/${id}`, typeData)
    return response.data
  },

  async deleteDocumentType(id) {
    const response = await api.delete(`/api/document-types/${id}`)
    return response.data
  },

  // Motivos de Cancelamento
  async getCancellationReasons(params = {}) {
    const response = await api.get('/api/cancellation-reasons', { params })
    return response.data
  },

  async createCancellationReason(reasonData) {
    const response = await api.post('/api/cancellation-reasons', reasonData)
    return response.data
  },

  async updateCancellationReason(id, reasonData) {
    const response = await api.put(`/api/cancellation-reasons/${id}`, reasonData)
    return response.data
  },

  async deleteCancellationReason(id) {
    const response = await api.delete(`/api/cancellation-reasons/${id}`)
    return response.data
  },

  // Configurações do Sistema
  async getSystemSettings(params = {}) {
    const response = await api.get('/api/system-settings', { params })
    return response.data
  },

  async updateSystemSetting(id, settingData) {
    const response = await api.put(`/api/system-settings/${id}`, settingData)
    return response.data
  },

  // ==================== COTAÇÕES ====================
  async getQuotations(params = {}) {
    const response = await api.get('/api/quotations', { params })
    return response.data
  },

  async getQuotation(id) {
    const response = await api.get(`/api/quotations/${id}`)
    return response.data
  },

  async createQuotation(quotationData) {
    const response = await api.post('/api/quotations', quotationData)
    return response.data
  },

  async updateQuotation(id, quotationData) {
    const response = await api.put(`/api/quotations/${id}`, quotationData)
    return response.data
  },

  async deleteQuotation(id) {
    const response = await api.delete(`/api/quotations/${id}`)
    return response.data
  },

  async convertQuotationToContract(id) {
    const response = await api.post(`/api/quotations/${id}/convert`)
    return response.data
  },

  async getQuotationsByClient(clientId) {
    const response = await api.get(`/api/quotations/client/${clientId}`)
    return response.data
  },

  async getQuotationStats() {
    const response = await api.get('/api/quotations/stats/overview')
    return response.data
  },

  // === REPORTS ===
  async getMonthlyPerformance(month, year) {
    const params = new URLSearchParams()
    if (month) params.append('month', month)
    if (year) params.append('year', year)

    const response = await api.get(`/api/reports/monthly-performance?${params}`)
    return response.data
  },

  async getDREDetailed(month, year) {
    const params = new URLSearchParams()
    if (month) params.append('month', month)
    if (year) params.append('year', year)

    const response = await api.get(`/api/reports/dre-detailed?${params}`)
    return response.data
  },

  async getClientAnalysis() {
    const response = await api.get('/api/reports/client-analysis')
    return response.data
  },

  async getFleetEfficiency() {
    const response = await api.get('/api/reports/fleet-efficiency')
    return response.data
  },

  async exportMonthlyReport(format, month, year) {
    const params = new URLSearchParams()
    if (month) params.append('month', month)
    if (year) params.append('year', year)

    const response = await api.get(`/api/reports/export/monthly-performance/${format}?${params}`, {
      responseType: 'blob'
    })

    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `relatorio_mensal_${month}_${year}.${format === 'excel' ? 'xlsx' : 'csv'}`)
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)

    return response
  },

  // ==================== FATURAS ====================
  async getInvoices(params = {}) {
    const response = await api.get('/api/invoices', { params })
    return response.data
  },

  async getInvoice(id) {
    const response = await api.get(`/api/invoices/${id}`)
    return response.data
  },

  async createInvoice(invoiceData) {
    const response = await api.post('/api/invoices', invoiceData)
    return response.data
  },

  async integrateInvoiceAsaas(id) {
    const response = await api.post(`/api/invoices/${id}/integrate-asaas`)
    return response.data
  },

  async generateInvoicePDF(id) {
    const response = await api.post(`/api/invoices/${id}/generate-pdf`)
    return response.data
  },

  async finalizeInvoice(id) {
    const response = await api.post(`/api/invoices/${id}/finalize`)
    return response.data
  },

  async updateInvoiceStatus(id, status) {
    const response = await api.put(`/api/invoices/${id}/status`, { status })
    return response.data
  },

  async markInvoiceAsPaid(id, paymentDate = null, bankAccountId = null, accountLabel = null) {
    const response = await api.post(`/api/invoices/${id}/mark-paid`, { paymentDate, bankAccountId, accountLabel })
    return response.data
  },

  async updateInvoiceDueDate(id, due_date, regenerate_charge = false, justification = null) {
    const response = await api.put(`/api/invoices/${id}/due-date`, { due_date, regenerate_charge, justification })
    return response.data
  },

  async updateInvoiceValue(id, new_value, regenerate_charge = false, justification = null) {
    const response = await api.put(`/api/invoices/${id}/value`, { new_value, regenerate_charge, justification })
    return response.data
  },

  async getInvoiceLogs(id) {
    const response = await api.get(`/api/invoices/${id}/logs`)
    return response.data
  },

  async updateInvoicePeriod(id, period_start, period_end) {
    const response = await api.put(`/api/invoices/${id}/period`, { period_start, period_end })
    return response.data
  },

  async updateInvoiceChargeDate(id, charge_date) {
    const response = await api.put(`/api/invoices/${id}/charge-date`, { charge_date })
    return response.data
  },

  async regenerateInvoicePDF(id, notes = undefined) {
    const response = await api.post(`/api/invoices/${id}/generate-pdf`, { force: true, ...(notes !== undefined && { notes }) })
    return response.data
  },

  async request(path, { method = 'GET', data } = {}) {
    const response = await api({ method, url: `/api${path}`, data })
    return response.data
  },

  async cancelInvoice(id, reason = null, justification = null) {
    const response = await api.delete(`/api/invoices/${id}`, { data: { reason, justification: justification || reason } })
    return response.data
  },

  async generateMonthlyInvoices(data = {}) {
    const response = await api.post('/api/invoices/generate-monthly', data)
    return response.data
  },

  async getInvoiceStatistics(params = {}) {
    const response = await api.get('/api/invoices/reports/statistics', { params })
    return response.data
  },

  async sendInvoiceEmail(id) {
    const response = await api.post(`/api/invoices/${id}/send-email`)
    return response.data
  },

  async sendInvoiceWhatsApp(id) {
    const response = await api.post(`/api/invoices/${id}/send-whatsapp`)
    return response.data
  },

  async generatePaymentReceipt(id) {
    const response = await api.post(`/api/invoices/${id}/generate-receipt`)
    return response.data
  }

}


export default apiService